import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../core';
import { UsuarioAlteraSenha } from '../usuario-altera-senha';

@Injectable({
    providedIn: 'root'
})
export class UsuarioAlteraSenhaHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`;
    }

    /** Altera a senha do usuário */
    alterarSenha(entity: UsuarioAlteraSenha): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${entity.id}/senha`, entity, {responseType: 'text'});
    }
}
